import { Observable } from "rxjs";
import { IAPIResponse } from "@domain/interfaces/apis/api-response.interface";
import { FeatureProductEnum } from "@domain/enums/product/feature-product.enum";

export abstract class ProductGateway {
    abstract activateUpsell(userId: number, productFeature: FeatureProductEnum): Observable<IAPIResponse>;
}